import FEGORender from '@futuweb/fego-render';
import FEGOEditor from '@futuweb/fego-editor';

const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10
};

// 加个开关
// 组件先不处理交互，交互由 Fego 上配置
export const onClickModule = (event) => {
    // render 下再去执行跳转逻辑
    // if (FEGORender) {
    //     const { common: { behavior: { runBehaviour } } } = FEGORender;
    //     const langMap = {
    //         0: 'zh-cn',
    //         1: 'zh-hk',
    //         2: 'en-us',
    //         5: 'ja',
    //     };
    //     // runBehaviour(event, {
    //     //     type: 'login',
    //     //     value: location.href,
    //     //     withQuery: true,
    //     //     lang: langMap[window.lang] || 'en-us'
    //     // }, event);
    // }
    // // editor 下直接返回
    return;
};

export const isMoo = () => {
    if (FEGOEditor) {
        const { app } = FEGOEditor;
        const { domain } = app.project.appInfo;
        return domain.indexOf('moomoo.com') > -1;
    }
    // FEGORender 下，通过域名是否带 moomoo.com 判断是否 moomoo 下
    return location.host.indexOf('moomoo.com') > -1;
};

export const isH5 = () => {
    let route = null;
    if (FEGORender) {
        const { store } = FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = FEGOEditor;
        route = project.route;
    }

    return route.now.pageType === PAGE_TYPE_ENUM.H5;
};

export const getEditorLang = () => {
    const lang = FEGOEditor?.app?.project?.route?.now?.lang?.toLowerCase();
    let ret = '';
    switch (lang) {
        case 'en':
            ret = 'en-us';
            break;
        case 'cn':
            ret = 'zh-cn';
            break;
        case 'hk':
            ret = 'zh-hk';
            break;
        case 'ja':
            ret = 'ja';
            break;
        default:
            ret = 'en-us';
    }
    return ret;
};

export const getIsPreRender = () => {
    return FEGORender.common.env.isPreRender;
};

/*
    解决Vue Template模板中使用可选链的问题
    @param obj
    @param rest
    @return {*}
*/
export const optionalChaining = (obj, ...rest) => {
    let tmp = obj;
    for (const key in rest) {
        const name = rest[key];
        tmp = tmp?.[name];
    }
    return tmp || '';
};

export const getEntity = () => {
    return window._extra['tool-date-formatter']?.options?.entity;
};
